import React, { useEffect, useState } from 'react';
import { CiLink } from 'react-icons/ci';
import { FaYoutube } from 'react-icons/fa6';
import { IoClose } from 'react-icons/io5';
import './cards.scss';

const Cards = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [card, setCard] = useState([]);

  const getAllCardData = async () => {
    try {
      const resp = await fetch('/data/db.json');
      if (!resp.ok) {
        throw new Error('Failed to fetch data');
      }
      const data = await resp.json();
      setCard(data.CardData);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getAllCardData();
  }, []); // Add empty dependency array to run only once on mount

  // Function to handle video display
  const handleWatchVideo = (videoUrl) => {
    setSelectedVideo(videoUrl);
  };

  // Function to handle video display
  const handleLiveShow = (LivePrev) => {
    setSelectedCard(LivePrev);
  };

  // Function to close the video popup
  const handleClosePopup = () => {
    setSelectedVideo(null);
  };

  // Function to close the Preview popup
  const handleCardClosePopup = () => {
    setSelectedCard(null);
  };

  const handleDownloadCode = (downloadUrl) => {
    window.open(downloadUrl, '_blank');
  };

  return (
    <>
      <div className="mainCardsReactCodes">
        <div className="subCardsReactCodes">
          {card.map((item, index) => (
            <div key={index} className="CardsReactCodes">
              <div className="listCardsReactCodes1 listCardsReactCodesImg">
                <img src={item.CardImages} alt={item.CardTitle} />
                <h4 onClick={() => handleDownloadCode(item.CardDownload)}>
                  {item.CardTitle}
                </h4>
              </div>
              <div className="listCardsReactCodes2">
                <div className="CardCodeBtns">
                  {/* <button onClick={() => handleLiveShow(item.CardLive)} target="_blank" rel="noopener noreferrer"><FaEye className='CardIcons' /></button> */}
                  <button
                    onClick={() => handleDownloadCode(item.CardDownload)}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <CiLink className="CardIcons" />
                  </button>
                  <button onClick={() => handleWatchVideo(item.CardVideoWatch)}>
                    <FaYoutube className="CardIcons" />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedCard && (
          <div className="CardPopup">
            <div className="subCardPopup">
              <span className="CardCloseButton" onClick={handleCardClosePopup}>
                <IoClose />
              </span>
              <iframe src={selectedCard}></iframe>
            </div>
          </div>
        )}

        {/* Popup for Video (only one at a time) */}
        {selectedVideo && (
          <div className="popup">
            <div className="popup-content">
              <span className="card-close-button" onClick={handleClosePopup}>
                <IoClose />
              </span>
              <iframe
                src={selectedVideo}
                title="Portfolio Video"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Cards;